import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StoreContext } from '../../components/Store';

export default function SettingsHeader({ heading }) {
  const store = useContext(StoreContext);
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    if (Object.keys(store.accountDetails?.[0]).length > 0) {
      setCompanyName(store.accountDetails[0].company);
    }
  }, [store.accountDetails?.[0]]);

  return (
    <div className="settings-page-header">
      <div className="left-column"></div>
      <div className="right-column">
        <div>{heading}</div>
        {companyName && <div>{companyName}</div>}
      </div>
    </div>
  );
}

SettingsHeader.propTypes = {
  heading: PropTypes.string,
};
